import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, {useState} from "react";
import DialogContentText from "@material-ui/core/DialogContentText";
import {Button, Typography} from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";

const ConfirmStartRideDialog = ({bikeNumber, onCancel, onStartRide}) => {
  const [t] = useTranslation();

  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Dialog open={true}>
      <DialogTitle>{t('unlockBike.confirmDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="body1" style={{textAlign: "justify"}}>
            {t('unlockBike.confirmDialog.content', {bikeNumber: bikeNumber})}
          </Typography>
        </DialogContentText>
        <DialogActions>
          <Button disabled={isSubmitting}
                  onClick={async () => {
                    setIsSubmitting(true);
                    await onStartRide(bikeNumber);
                    setIsSubmitting(false);
                  }}
                  color="primary"
                  variant="contained"
          >
            {t('unlockBike.confirmDialog.unlockAndRental')}
          </Button>
          <Button
            disabled={isSubmitting}
            onClick={onCancel}
            color="secondary"
          >
            {t('common.cancelButton')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

ConfirmStartRideDialog.propTypes = {
  bikeNumber: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onStartRide: PropTypes.func.isRequired,
};
export default ConfirmStartRideDialog;
